<template>
  <div class="homePage">
    <div class="message flex-rowl">
      <div class="icon"><i class="iconfont icon-iconxx1"></i></div>
      <div class="txt">收到了新的业务消息</div>
    </div>
    <div class="card_list" v-if="dept.role">
      <div
        class="card_item flex-rowl"
        @click="handleGO(1)"
        v-if="dept.role == 2 || dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 扫码取餐
      </div>
      <div
        class="card_item flex-rowl"
        @click="handleGO(2)"
        v-if="dept.role == 3 || dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 扫码送餐
      </div>
      <div
        class="card_item flex-rowl"
        @click="handleGO(3)"
        v-if="dept.role == 4 || dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 扫码分派处理
      </div>

      <div
        class="card_item flex-rowl"
        @click="handleGO(4)"
        v-if="dept.role == 4 || dept.role == 1"
      >
        <i class="iconfont icon-iconfontscan"></i> 故障上报
      </div>
      <!-- <div class="card_item flex-rowl" @click="handleGO()">
        <i class="iconfont icon-iconfontscan"></i> 扫码测试
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      isShow: false,
      dept: "",
      userInfo: "",
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO
    if(userInfo.dept.length > 0) {
      this.dept = userInfo.dept[0]
    }
  },
  methods: {
    handleGO(type) {
      if(type == 4) {
        this.$toast('即将开放')
        return
      }
      this.$router.push(`/qrcode/${type}`);
      // if (type == 1) {
      //   this.$router.push(`/qrcode/${type}`);
      // } else if (type == 2) {
      //   this.$router.push(`/qrcode/${type}`);
      //   this.$router.push("/sendMeal/sMealIndex/"+type);
      // } else if (type == 3) {
      //   this.$router.push("/dispatch");
      // }else {
      //   this.$router.push("/qrcode");
      // }
    },
  },
};
</script>
<style lang='less' scoped>
.homePage {
  .message {
    width: 640px;
    margin: 100px auto 80px;
    font-size: 20px;
    color: #1e1e1e;
    .icon-iconxx1 {
      font-size: 46px;
      margin-right: 30px;
    }
    .txt {
      flex: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .card_list {
    .card_item {
      width: 660px;
      height: 130px;
      background: #ffffff;
      box-shadow: 0px 9px 30px 0px rgba(4, 0, 0, 0.09);
      border-radius: 40px;
      font-size: 28px;
      color: #000000;
      margin: auto;
      padding: 0 45px;
      box-sizing: border-box;
      margin-bottom: 30px;
      .icon-iconfontscan {
        color: #ea3329;
        font-size: 40px;
        margin-right: 35px;
      }
    }
  }
}
</style>